'use strict';

angular.module('far.insurance')
    .controller('InsuranceWrapperController', function($scope, $log, $timeout, $window, $location, $anchorScroll) {
        $anchorScroll.yOffset = 90;

        $scope.gotoAnchor = function(x) {
            if ($location.hash() !== x) {
                $location.hash(x);
            } else {
                $anchorScroll();
            }
        };        
    });